import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  textCodes,
  titleCodes,
} from "../../template_codes/willow/home_page_codes";
import logo from "../../assets/images/willow/willow_logo.jpg";
import { useTranslate, locales } from "../../translate";

function Home() {
  const { locale, setLocale } = useTranslate();
  const localeIsMMM = locale === "mm";
  return (
    <div>
      {/*             header menu              */}
      <div class="navbar bg-base-100">
        <div class="flex-1">
          <Link to={paths.home}>
            <img src={logo} alt="logo" width={122} height={38} />
          </Link>
        </div>
        <div class="flex-none gap-2">
          <a href="https://willowlabelmm.com/" className="text-xl uppercase">
            {localeIsMMM ? textCodes.shopTextMM.text : textCodes.shopText.text}
          </a>
          {locale === "en" ? (
            <p
              className="text-xl uppercase hover:link"
              onClick={() => setLocale(locales.myanmar)}
            >
              {textCodes.myanmar.text}
            </p>
          ) : (
            <p
              className="text-xl uppercase hover:link"
              onClick={() => setLocale(locales.english)}
            >
              {textCodes.eng.text}
            </p>
          )}
        </div>
      </div>
      {/*             header menu              */}

      {/*              slider section               */}
      <div class="carousel w-full pt-2 pb-10">
        <div id="slide1" class="carousel-item relative w-full">
          <img src={imageCodes.sliderOne.image} class="w-full" />
          <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
            <a href="#slide3" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❮
            </a>
            <a href="#slide2" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❯
            </a>
          </div>
        </div>
        <div id="slide2" class="carousel-item relative w-full">
          <img src={imageCodes.sliderTwo.image} class="w-full" />
          <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
            <a href="#slide1" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❮
            </a>
            <a href="#slide3" class="btn btn-circle bg-[#d4c4b5] border-0">
              ❯
            </a>
          </div>
        </div>
        <div id="slide3" class="carousel-item relative w-full">
          <a href="https://willowlabelmm.com/shop?cat=man">
            <img src={imageCodes.sliderThree.image} class="w-full" />
            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#slide2" class="btn btn-circle bg-[#d4c4b5] border-0">
                ❮
              </a>
              <a href="#slide1" class="btn btn-circle bg-[#d4c4b5] border-0">
                ❯
              </a>
            </div>
          </a>
        </div>
      </div>
      {/*              slider section               */}

      {/*              category section              */}
      <div className="py-14">
        <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pl-4 xl:pl-16 2xl:pl-20">
          {localeIsMMM
            ? titleCodes.ourProductMM.title
            : titleCodes.ourProduct.title}
        </h1>

        <div class="carousel carousel-end rounded-box">
          <div class="carousel-item p-4">
            <div class="card w-96 bg-base-100 shadow-xl">
              <figure>
                <a href="https://willowlabelmm.com/">
                  <img src={imageCodes.feature4.image} alt="Shoes" />
                </a>
              </figure>
              <div class="card-body">
                <a href="https://willowlabelmm.com/">
                  <h2 class="card-title pb-4">Man</h2>
                  <p>{textCodes.manText.text}</p>
                  <div class="card-actions justify-end pt-4">
                    <div class="badge badge-outline">Man</div>
                    <div class="badge badge-outline">Fashion</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="carousel-item p-4">
            <div class="card w-96 bg-base-100 shadow-xl">
              <figure>
                <a href="https://willowlabelmm.com/">
                  <img src={imageCodes.feature1.image} alt="Shoes" />
                </a>
              </figure>
              <div class="card-body">
                <a href="https://willowlabelmm.com/">
                  <h2 class="card-title pb-4">Woman</h2>
                  <p>{textCodes.womenText.text}</p>
                  <div class="card-actions justify-end pt-4">
                    <div class="badge badge-outline">Woman</div>
                    <div class="badge badge-outline">Fashion</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="carousel-item p-4">
            <div class="card w-96 bg-base-100 shadow-xl">
              <figure>
                <a href="https://willowlabelmm.com/">
                  <img src={imageCodes.feature2.image} alt="Shoes" />
                </a>
              </figure>
              <div class="card-body">
                <a href="https://willowlabelmm.com/">
                  <h2 class="card-title pb-4">Boy</h2>
                  <p>{textCodes.boyText.text}</p>
                  <div class="card-actions justify-end pt-4">
                    <div class="badge badge-outline">Boy</div>
                    <div class="badge badge-outline">Fashion</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="carousel-item p-4">
            <div class="card w-96 bg-base-100 shadow-xl">
              <figure>
                <a href="https://willowlabelmm.com/">
                  <img src={imageCodes.feature3.image} alt="Shoes" />
                </a>
              </figure>
              <div class="card-body">
                <a href="https://willowlabelmm.com/">
                  <h2 class="card-title pb-4">Girl</h2>
                  <p>{textCodes.girlText.text}</p>
                  <div class="card-actions justify-end pt-4">
                    <div class="badge badge-outline">Girl</div>
                    <div class="badge badge-outline">Fashion</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*              end of category section              */}

      {/*              story section              */}

      <div className="container p-4 lg:p-8 xl:p-10 2xl:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-2">
          <div className="text-justify pt-8">
            <p className="text-xs lg:text-lg xl:text-lg pb-2 lowercase font-extralight">
              {localeIsMMM
                ? titleCodes.ourStoryMM.title
                : titleCodes.ourStory.title}
            </p>
            <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">
              {localeIsMMM
                ? titleCodes.whoTitleMM.title
                : titleCodes.whoTitle.title}
            </h1>
            <p className="tracking-wider text-lg pb-4">
              {localeIsMMM ? textCodes.story1MM.text : textCodes.story1.text}
            </p>
            <p className="tracking-wider text-lg">
              {localeIsMMM ? textCodes.story3MM.text : textCodes.story3.text}
            </p>
          </div>
          <div>
            <img src={imageCodes.whoWeAre.image} className="p-2"></img>
          </div>
        </div>
      </div>
      {/*              end of story section              */}

      {/*              story section 2              */}

      <div className="container p-4 lg:p-8 xl:p-10 2xl:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-2">
          <div>
            <img src={imageCodes.weDo.image} className="p-2"></img>
          </div>
          <div>
            <div className="text-justify pt-8">
              <p className="text-xs lg:text-lg xl:text-lg pb-2 lowercase font-extralight">
                {localeIsMMM
                  ? titleCodes.ourStoryMM.title
                  : titleCodes.ourStory.title}
              </p>
              <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-8">
                {localeIsMMM
                  ? titleCodes.doTitleMM.title
                  : titleCodes.doTitle.title}
              </h1>
              <p className="tracking-wider text-lg pb-4">
                {localeIsMMM ? textCodes.wedo1MM.text : textCodes.wedo1.text}
              </p>
              <p className="tracking-wider text-lg">
                {localeIsMMM ? textCodes.wedo2MM.text : textCodes.wedo2.text}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/*              end of story section 2             */}

      {/*              instagram photo section              */}
      {/* <div className="container p-10">
        <div className="text-center">
          <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pb-2">
            {localeIsMMM
              ? titleCodes.featurePhotosMM.title
              : titleCodes.featurePhotos.title}
          </h1>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 pb-4">
          <div>
            <img src={imageCodes.featurePhoto1.image}></img>
          </div>
          <div>
            <img src={imageCodes.featurePhoto2.image}></img>
          </div>
          <div>
            <img src={imageCodes.featurePhoto3.image}></img>
          </div>
          <div>
            <img src={imageCodes.featurePhoto4.image}></img>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-3">
          <div>
            <img src={imageCodes.featurePhoto5.image}></img>
          </div>
          <div>
            <img src={imageCodes.featurePhoto6.image}></img>
          </div>
          <div>
            <img src={imageCodes.featurePhoto7.image}></img>
          </div>
        </div>
      </div> */}
      {/*              end of instagram photo section              */}

      {/*             featured section            */}
      <div className="container w-4/5 p-10">
        <div className="text-center">
          <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pt-8">
            {localeIsMMM
              ? titleCodes.featurePhotosMM.title
              : titleCodes.featurePhotos.title}
          </h1>
        </div>
        <div class="carousel pt-4">
          <div id="featuredphoto1" class="carousel-item relative w-full">
            <div>
              <div className="grid grid-cols-3 gap-3 pb-4">
                <div>
                  <img src={imageCodes.featurePhoto5.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto6.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto7.image}></img>
                </div>
              </div>
              <div className="grid grid-cols-4 gap-3">
                <div>
                  <img src={imageCodes.featurePhoto1.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto2.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto3.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto4.image}></img>
                </div>
              </div>
            </div>
          </div>
          <div id="featuredphoto2" class="carousel-item relative w-full">
            <div>
              <div className="grid grid-cols-4 gap-3 pb-4">
                <div>
                  <img src={imageCodes.featurePhoto8.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto9.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto10.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto11.image}></img>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <img src={imageCodes.featurePhoto12.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto13.image}></img>
                </div>
                <div>
                  <img src={imageCodes.newfeature1.image}></img>
                </div>
              </div>
            </div>
          </div>
          <div id="featuredphoto3" class="carousel-item relative w-full">
            <div>
              <div className="grid grid-cols-4 gap-3">
                <div>
                  <img src={imageCodes.featurePhoto14.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto15.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto16.image}></img>
                </div>
                <div>
                  <img src={imageCodes.featurePhoto17.image}></img>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <img src={imageCodes.newfeature4.image}></img>
                </div>
                <div>
                  <img src={imageCodes.newfeature3.image}></img>
                </div>
                <div>
                  <img src={imageCodes.newfeature2.image}></img>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center w-full py-2 gap-2">
          <a href="#featuredphoto1" className="btn btn-xs bg-[#d4c4b5]">
            1
          </a>
          <a href="#featuredphoto2" className="btn btn-xs bg-[#d4c4b5]">
            2
          </a>
          <a href="#featuredphoto3" className="btn btn-xs bg-[#d4c4b5]">
            3
          </a>
        </div>
      </div>
      {/*             end of featured section            */}

      {/*             customer feedback section            */}
      <div className="container p-10">
        <div className="text-center">
          <h1 className="text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase pt-8">
            {localeIsMMM
              ? titleCodes.prettyCustomersMM.title
              : titleCodes.prettyCustomers.title}
          </h1>
        </div>
        <div className="container w-4/5">
          <div class="carousel pt-4">
            <div id="reviewphoto1" class="carousel-item relative w-full">
              <div>
                <div className="grid grid-cols-4 gap-3 pb-4">
                  <div>
                    <img src={imageCodes.review1.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review2.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review3.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review4.image}></img>
                  </div>
                </div>
              </div>
            </div>
            <div id="reviewphoto2" class="carousel-item relative w-full">
              <div>
                <div className="grid grid-cols-4 gap-3">
                  <div>
                    <img src={imageCodes.review5.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review6.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review7.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review8.image}></img>
                  </div>
                </div>
              </div>
            </div>
            <div id="reviewphoto3" class="carousel-item relative w-full">
              <div>
                <div className="grid grid-cols-4 gap-3">
                  <div>
                    <img src={imageCodes.review9.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review10.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review11.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review12.image}></img>
                  </div>
                </div>
              </div>
            </div>
            <div id="reviewphoto4" class="carousel-item relative w-full">
              <div>
                <div className="grid grid-cols-4 gap-3">
                  <div>
                    <img src={imageCodes.review13.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review14.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review15.image}></img>
                  </div>
                  <div>
                    <img src={imageCodes.review16.image}></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full py-2 gap-2">
            <a href="#reviewphoto1" className="btn btn-xs bg-[#d4c4b5]">
              1
            </a>
            <a href="#reviewphoto2" className="btn btn-xs bg-[#d4c4b5]">
              2
            </a>
            <a href="#reviewphoto3" className="btn btn-xs bg-[#d4c4b5]">
              3
            </a>
            <a href="#reviewphoto4" className="btn btn-xs bg-[#d4c4b5]">
              4
            </a>
          </div>
        </div>
      </div>

      {/* <div className="container w-4/5">
        <div class="carousel pt-10">
          <div id="feedback1" class="carousel-item relative w-full">
            <div class="hero">
              <div class="hero-content flex-col lg:flex-row">
                <img
                  src="https://placeimg.com/400/300/arch"
                  class=" rounded-lg shadow-2xl"
                />
                <div>
                  <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">
                    Customer Feedback1
                  </h1>
                  <p class="py-6 pt-20">
                    Provident cupiditate voluptatem et in. Quaerat fugiat ut
                    assumenda excepturi exercitationem quasi. In deleniti eaque
                    aut repudiandae et a id nisi.
                  </p>
                </div>
              </div>
            </div>
            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#feedback4" className="bg-[#d4c4b5]">❮</a>
              <a href="#feedback2">❯</a>
            </div>
          </div>
          <div id="feedback2" class="carousel-item relative w-full">
            <div class="hero">
              <div class="hero-content flex-col lg:flex-row">
                <img
                  src="https://placeimg.com/400/300/arch"
                  class=" rounded-lg shadow-2xl"
                />
                <div>
                  <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">
                    Customer Feedback2
                  </h1>
                  <p class="py-6 pt-20">
                    Provident cupiditate voluptatem et in. Quaerat fugiat ut
                    assumenda excepturi exercitationem quasi. In deleniti eaque
                    aut repudiandae et a id nisi.
                  </p>
                </div>
              </div>
            </div>
            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#feedback1">❮</a>
              <a href="#feedback3">❯</a>
            </div>
          </div>
          <div id="feedback3" class="carousel-item relative w-full">
            <div class="hero">
              <div class="hero-content flex-col lg:flex-row">
                <img
                  src="https://placeimg.com/400/300/arch"
                  class=" rounded-lg shadow-2xl"
                />
                <div>
                  <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">
                    Customer Feedback3
                  </h1>
                  <p class="py-6 pt-20">
                    Provident cupiditate voluptatem et in. Quaerat fugiat ut
                    assumenda excepturi exercitationem quasi. In deleniti eaque
                    aut repudiandae et a id nisi.
                  </p>
                </div>
              </div>
            </div>
            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#feedback2">❮</a>
              <a href="#feedback4">❯</a>
            </div>
          </div>
          <div id="feedback4" class="carousel-item relative w-full">
            <div class="hero">
              <div class="hero-content flex-col lg:flex-row">
                <img
                  src="https://placeimg.com/400/300/arch"
                  class=" rounded-lg shadow-2xl"
                />
                <div>
                  <h1 class="text-center text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-semibold">
                    Customer Feedback4
                  </h1>
                  <p class="py-6 pt-20">
                    Provident cupiditate voluptatem et in. Quaerat fugiat ut
                    assumenda excepturi exercitationem quasi. In deleniti eaque
                    aut repudiandae et a id nisi.
                  </p>
                </div>
              </div>
            </div>
            <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#feedback3">❮</a>
              <a href="#feedback1">❯</a>
            </div>
          </div>
        </div>
      </div> */}
      {/*             end of customer feedback section            */}

      {/*              track order and media section              */}
      <div className="container p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8 pt-14">
          <div className="bg-willow_trackOrder bg-cover">
            <div className="container w-56 lg:w-80 xl:w-80 2xl:w-80 text-center py-44">
              <Link to={paths.shipping}>
                <h1 className="bg-[#ffffff80] text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase py-4">
                  {localeIsMMM
                    ? titleCodes.trackYourOrderMM.title
                    : titleCodes.trackYourOrder.title}
                </h1>
              </Link>
            </div>
          </div>
          <div className="bg-willow_mediaRoom bg-cover">
            <div className="container w-56 lg:w-80 xl:w-80 2xl:w-80 text-center py-44">
              <Link to={paths.media}>
                <h1 className="bg-[#ffffff80] text-xl lg:text-3xl xl:text-3xl 2xl:text-3xl uppercase py-4">
                  {localeIsMMM
                    ? titleCodes.mediaRoomTitleMM.title
                    : titleCodes.mediaRoomTitle.title}
                </h1>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/*              end of track order and media section              */}
    </div>
  );
}

export default Home;
